<template></template>

<script>
//@deprecated
export default {
  data: function () {
    return {
      categories: [],
    };
  },
  props: ["queryUrl"],
  mounted() {
    this.queryApi();
  },
  methods: {
    /**
     * Query the internal API to trigger a free lookup on MotorCheck
     *
     * @return  {void}
     */
    queryApi() {
      axios
        .get(this.queryUrl)
        .then((response) => {
          this.error = false;

          this.categories = this.categories.concat(response.data.data);
        })
        .catch((error) => {
          this.error = true;
        });
    },
  },
};
</script>
